import React from "react";
import DiffMode from "./DiffMode";
import DiffView from "./DiffView";
import { DiffModeOption } from "types/WorkbookDiff";
import { DiffProvider } from "./DiffProvider";
import Callout from "ui/Callout";

const WorkbookDiff = ({
  original,
  modified,
  options,
  className,
  canExpand = false,
  isBaseline = false,
  onChangeSQLEditor,
  displayCTA = false,
  diffViewClassName = "",
  defaultModeIndex = 0,
}: {
  original: string;
  modified: string;
  options: DiffModeOption[];
  canExpand?: boolean;
  className?: string;
  isBaseline?: boolean;
  onChangeSQLEditor?: (sql: string) => void;
  displayCTA?: boolean;
  diffViewClassName?: string;
  defaultModeIndex?: number;
}) => {
  const defaultMode = options[defaultModeIndex].value;
  return (
    <div className={className}>
      <DiffProvider initialValue={defaultMode}>
        {!isBaseline && <DiffMode options={options} />}
        {displayCTA && (
          <Callout className="mb-2" thin>
            Both plans have an identical structure
          </Callout>
        )}
        <DiffView
          className={diffViewClassName}
          original={original}
          modified={modified}
          isBaseline={isBaseline}
          defaultMode={defaultMode}
          canExpand={canExpand}
          onChangeSQLEditor={onChangeSQLEditor}
        />
      </DiffProvider>
    </div>
  );
};

export default WorkbookDiff;
